import { motion } from 'framer-motion';
import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import {
  mediaDesktop,
  mediaDesktopLarge,
  mediaTablet,
} from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

import { validButtonThemes } from './Button';

const matchTypeStyles = (buttonType: '' | typeof validButtonThemes[number]) => {
  switch (buttonType) {
    case 'red':
      return `
        border: 1rem solid ${colors.cinnabar};
        background: ${colors.cinnabar};
      `;
    case 'black':
      return `
        border: 1rem solid rgba(0, 0, 0, 0.8);
        background: rgba(0, 0, 0, 0.8);
        &:hover {
          background: rgba(0, 0, 0, 1);
        }
      `;
    default:
      return `
        border: 1rem solid ${colors.white};
        background: transparent;
        svg {
          color: ${colors.white};
        }
        &:hover {
          background: ${colors.white};
          span {
            color: ${colors.taupe};
          }
          svg {
            path {
              fill: ${colors.taupe};
            }
          }
        }
      `;
  }
};

export const Wrapper = styled(motion.button)<{
  isActive?: boolean;
  variant: '' | typeof validButtonThemes[number];
}>`
  padding: 10rem 40rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  height: 115rem;
  cursor: pointer;
  gap: 5rem;
  transition: all 0.3s ease-in-out;
  ${({ variant }) => matchTypeStyles(variant)};

  ${({ isActive }) =>
    isActive &&
    `
    background: ${colors.white};
    transition: all 0.3s ease-in-out;
    span {
      color: ${colors.taupe};
    }
    svg {
      color: ${colors.taupe};
    }
  `}

  ${mediaTablet`
    height: 95rem;
  `}

  ${mediaDesktop`
    height: 115rem;
  `}
`;

export const Text = styled.span`
  color: ${colors.white};
  ${({ theme: { locale } }) => setTypography('button', locale)}
  text-align: center;
  transition: all 0.3s ease-in-out;
  user-select: none;
  white-space: pre;
`;

export const IconWrapper = styled.span`
  width: 80rem;
  height: 80rem;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
    height: 100%;
    path {
      transition: all 0.3s ease-in-out;
    }
  }

  ${mediaTablet`
    width: 50rem;
    height: 50rem;
  `}

  ${mediaDesktop`
    width: 60rem;
    height: 60rem;
  `}

  ${mediaDesktopLarge`
    width: 60rem;
    height: 60rem;
  `}
`;
